import gql from 'graphql-tag';
const getToysQuery = gql(`
  query getToys($from: Int!, $size: Int!, $public: Boolean) {
    getToys(from: $from, size: $size, public: $public) {
      items {
        id,
        name,
        description,
        thumbnailImage,
        toy
        public
      }
    }
  }
`);

const whoamiQuery = gql(`
  query whoami {
    whoami {
      username
      id
    }
  }

`);

const listImagesQuery = gql`
  query($from: Int, $search: String, $size: Int) {
    getImages(from: $from, search: $search, size: $size) {
      nextToken,
      items {
        id
        name
      }
    }
  }
`
const listVideosQuery = gql`
  query($from: Int, $search: String, $size: Int) {
    getVideos(from: $from, search: $search, size: $size) {
      total,
      items {
        id
        name
        thumbnail
        width
        height
      }
    }
  }
`

const getAnimationsQuery = gql`
  query($from: Int, $size: Int) {
    getAnimations(from: $from, size: $size) {
      items {
        id
        name
        thumbnail
        loopByDefault
        timePerFrame
        frames
      }
    }
  }
`
const listSpritesheetsQuery = gql`
  query($from: Int, $search: String, $size: Int) {
    getSpritesheets(from: $from, search: $search, size: $size) {
      total,
      items {
        id
        name,
        pack,
        detected_text,
        thumbnailImage,
        gridx,
        gridy,
        autoscale
      }
    }
  }
`

const listPacksQuery = gql`
  query($nextToken: String, $search: String, $size: Int) {
    getPacks(nextToken: $nextToken, search: $search, size: $size) {
      nextToken,
      items {
        id
        name,
        thumbnailImage,
        items {
          layer {
            id
            name
            gridx
            gridy
            autoscale
            projection
            zindex
          }
          toysheets {
            sprites {
              image {
                id
              }
            }
            spritesheets {
              spritesheet {
                id
                name
                pack
                thumbnailImage
              }
            }
            toys {
              limit
              toy {
                id
                name
                description
                thumbnailImage
                toy
              }
            }
            autotoys {
              name
              rootComponent
              components
              links
              transform
            }
          }
        }
      }
    }
  }
`

const getPostsQuery = gql(`
  query getPosts($type: String, $from: Int, $size: Int) {
    getPosts(type: $type, from: $from, size: $size) {
      total
      items {
        id
        title
        game
        author {
          id
          username
        }
        downvotes
        upvotes
        parent {
          id
          title
          author {
            id
            username
          }
        }
        type
        body
        image
        metadata {
          cols
          rows
        }

        clips {
          thumbnail
        }

      }
    }
  }
`);

const getPostsForQuery = gql(`
  query getPosts($parent: String!, $type: String!, $nextToken: String, $size: Int) {
    getPostsFor(parentId: $parent, type: $type, nextToken: $nextToken, size: $size) {
      nextToken
      items {
        id
        title
        game
        author {
          id
          username
        }
        downvotes
        upvotes
        parent {
          id
          title
          author {
            id
            username
          }
        }
        replies {
          total
        }
        type
        body
        image
        metadata {
          cols
          rows
        }

        clips {
          thumbnail
        }

      }
    }
  }
`);

const getPostDraftsQuery = gql(`
{
  postDrafts @client {
    id,
    created,
    updated,
    title,
    gamedata,
    parentId,
    opId
  }
}
`);
const getLocalMemes = gql(`
{
  localMemes @client {
    id,
    title,
    game
    parent,
    op
  }
}
`);


const savePostDraftQuery = gql(`
  mutation($id: String!, $created: String!, $updated: String!, $title: String!, $gamedata: String!, $parentId: String!, $opId: String!) {
    savePostDraft(id: $id, created: $created, updated: $updated, title: $title, gamedata: $gamedata, parentId: $parentId, opId: $opId) @client {
      id
      created
      updated
      title
      gamedata
      parentId
      opId

    }
  }
`);
const addLocalMeme = gql(`
  mutation($id: String!, $title: String!, $game: String!, $op: String!, $parent: String!) {
    addLocalMeme(id: $id, title: $title, game: $game, op: $op, parent: $parent) @client {
      id,
      title,
      game,
      op,
      parent
    }
  }
`);


const deletePostDraft = gql(`
  mutation($id: String!) {
    deletePostDraft(id: $id) @client
  }
`);
const getRecorderPostQuery = gql(`
query getPost($id: String!) {
  getPost(id: $id) {
    id
    title
    author {
      id
      username
    }
    game
    upvotes
    downvotes
  }
}
`)
const getGameQuery = gql(`
  query getGame($id: String!) {
    getGame(id: $id)
  }
`)
const postAddedSubscription = gql(`
        subscription addedPost {
          addedPost {
            id
            title
            game
            author {
              id
              username
            }
            upvotes
            downvotes
          }
        }
        `);
const clipAddedSubscription = gql(`
        subscription addedClip {
          addedClip {
            id
            postId
            status
            mp4Url
            gifUrl
            aspect
            progress
            mp4Size
            gifSize
            thumbnail
            resolution

          }
        }
        `);

const savePostStash = gql(`
  mutation {
    getSignedPostStashUrl{
      id
      url
    }
  }

`);

const getPostQuery = gql(`
query getPost($id: String!) {
  getPost(id: $id) {
    id
    title
    author {
      id
      username
    }
    parent {
      id
      title
      author {
        id
        username
      }
    }
    game
    upvotes
    downvotes
    clips {
      id
      name
      postId
      status
      mp4Url
      gifUrl
      aspect
      progress
      mp4Size
      gifSize
      thumbnail
      screenshots {
        id
        timestamp
        thumbnail
        resolution
      }
    }
    replies {
      total
    }
    image
    type
    metadata {
      cols
      rows
    }
  }
}
`)

const updatePostMutation = gql(`
  mutation($id: String!, $pinned: Long, $hidden: Boolean) {
    updatePost(id: $id, pinned: $pinned, hidden: $hidden) {
      id
    }
  }
`);

const listRemoteVideos = gql(`
  query($size: Int, $cursor: String, $search: String) {
    listRemoteVideos(cursor: $cursor, search: $search, size: $size) {
      cursor
      items {
        mp4Url
        gifUrl
        thumbnailGifUrl
        thumbnailUrl
      }
      related
    }
  }

`);
const listRemoteAnimations = gql(`
  query($size: Int, $cursor: String, $search: String) {
    listRemoteAnimations(cursor: $cursor, search: $search, size: $size) {
      cursor
      items {
        webpUrl
        gifUrl
      }
      related
    }
  }

`);

const getTemplateQuery = gql(`
  query($id: String!) {
    getTemplate(id: $id) {
      id
      title
      thumbnailImage
      labels
      tags
      data
      public
    }
  }
`)

const getTemplatesQuery = gql(`
  query($nextToken: String!, $size: Int!, $public: Boolean) {
    getTemplates(nextToken: $nextToken, size: $size, public: $public) {
      nextToken
      items {
        id
        title
        thumbnailImage
        labels
        tags
        public
      }
    }
  }
`)


/*
const uploadRemoteAnimation = gql(`
  mutation($url: String) {
    uploadRemoteAnimation(url: $url) {
      id
      name
      thumbnail
      loopByDefault
      timePerFrame
      frames
    }
  }

`);
*/
const uploadRemoteAnimation = gql(`
  mutation($url: String) {
    uploadRemoteAnimation(url: $url) {
      importId
    }
  }

`);

const uploadRemoteVideo = gql(`
  mutation($url: String!, $thumbnailUrl: String) {
    uploadRemoteVideo(url: $url, thumbnailUrl: $thumbnailUrl) {
      id
      name
      thumbnail
      width
      height
    }
  }

`);

const getUser= gql(`
  query($username: String) {
    getUser(username: $username) {
      username
      createdAt
      stats {
        totalPosts
        textPosts
        opCount
      }
    }
  }`);

const getUserPosts = gql(`
  query($username: String, $nextToken: String, $size: Int) {
    getUserPosts(username: $username, nextToken: $nextToken, size: $size) {
      nextToken
      items {
        id
        title
        game
        author {
          id
          username
        }
        downvotes
        upvotes
        parent {
          id
          title
          author {
            id
            username
          }
        }
        replies {
          total
        }
        type
        body
        image
        metadata {
          cols
          rows
        }

        clips {
          thumbnail
         }

      }
    }

  }
`);

const claimAnonPostMutation = gql(`
  mutation($id: String!) {
    claimAnonPost(id: $id)
  }

`);
const deleteLocalMeme = gql(`
  mutation($id: String!) {
    deleteLocalMeme(id: $id) @client
  }
`);

const updateTemplateMutation = gql(`
  mutation($id: String!, $data: String, $title: String, $thumbnailImage: String, $labels: String, $tags: String, $public: Boolean) {
    updateTemplate(id: $id, data: $data, title: $title, thumbnailImage: $thumbnailImage, labels: $labels, tags: $tags, public: $public) {
      id
      title
      thumbnailImage
      labels
      tags
      data
      public
    }
  }
`);

const voteMutation = gql(`
  mutation votePost($id: String!, $type: String!) {
    votePost(id: $id, type: $type) {
      id
      upvotes
      downvotes
    }
  }
`);
export {
  listImagesQuery,
  getPostsQuery,
  getPostsForQuery,
  getPostDraftsQuery,
  savePostDraftQuery,
  deletePostDraft,
  listSpritesheetsQuery,
  getAnimationsQuery,
  listPacksQuery,
  whoamiQuery,
  listVideosQuery,
  getToysQuery,
  getRecorderPostQuery,
  getGameQuery,
  postAddedSubscription,
  clipAddedSubscription,
  savePostStash,
  getPostQuery,
  updatePostMutation,
  listRemoteAnimations,
  uploadRemoteAnimation,
  getTemplateQuery,
  getTemplatesQuery,
  getUser,
  getUserPosts,
  addLocalMeme,
  getLocalMemes,
  claimAnonPostMutation,
  deleteLocalMeme,
  updateTemplateMutation,
  uploadRemoteVideo,
  listRemoteVideos,
  voteMutation
}
